
import PageContent from 'layouts/PageContent';
import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import VisitLogRegister from './VisitLogRegister';


const VisitLogRegisterScreen = (props) => {
  const { t } = useTranslation(['visitLog', 'common']);  
  const [Reflesh, setReflesh] = useState(1);  
  const { ClaUbicacion } = props.match.params

  useEffect(() => {
    console.log(props.match.params);
  }, []);

  const onSearch = ()=>{
    setReflesh(Reflesh+1);
  }
  
  return (
    <PageContent title={t('visitLog:VisitLog')}>
      <Row>
        <Col lg={12} md={12} sm={12} xs={12}>
          <VisitLogRegister
            onSearch={onSearch}                 
            refresh={Reflesh}   
            ClaUbicacion={ClaUbicacion}
          >
          </VisitLogRegister>
        </Col>
      </Row>
    </PageContent>
  )
}

export default VisitLogRegisterScreen

